<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div style="width: 770px; margin: 0 auto">
          <div style="width: 750px; margin: 0 auto">
            <p class="font_size">{{ profile }}</p>
            <img :src="VRImg" alt="暂无照片" />
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      profile: "",
      VRImg: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_tiyan.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_tiyan.jpg",
          p:
            "主要包括安全帽撞击体验、劳保用品展示、电子消防安全演示及体验、假人模拟心肺复苏急救体验、安全综合用电体验、" +
            "隧道坍塌逃生体验、洞口（高空）坠落体验及VR场景伤害体验等，涵盖了工程施工中会经历到的各类易发安全事故。让一线施工人员能更直观、" +
            "生动、形象地认识到工作环境中面临的各种危险源，从而加深施工人员的安全防范记忆，提高安全意识，降低事故率。",
          VRImg: "../../../static/img/photo-da/photo_tiyan.jpg",
          ref: "VR安全质量体验馆",
          money: "",
          classify: [
            {
              type: "深蓝色",
              money: "",
              img: "../../../static/img/photo-da/photo_tiyan.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "VR安全质量体验馆",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_safety.png",
          photoUrl1: "../../../static/img/photo-da/photo_safety.png",
          p:
            "VR安全体验馆是通过电脑模拟，占地空间小。体验人员通过虚拟环境了解体验项目，不能亲身接触。主要应用于企事业单位、学校、社区等场所。\n" +
            "主要作用:\n" +
            "将施工安全教育与体验相结合，对施工人员进行安全教育时，通过亲身体验各种安全防护用品的使用及出现危险瞬间的感受，增强施工人员在施工现场时的切身感受，让安全理念深入人心，有效加强施工人员的安全意识。",
          VRImg: "../../../static/img/photo-da/photo_safety.png",
          ref: "安全网对比展示",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_safety.png",
            },
          ],
          title: "建筑工程体验馆",
          belong: "安全网对比展示",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_move.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_move.jpg",
          p:
            "重物体验的应用和作用：　\n" +
            "1、在工作之前，应该做好热身运动，减少瞬间扭伤拉伤，。\n" +
            "2、体验时要双手均衡抓取，达到锻炼身体，掌握面对重物时的正确搬运方法。",
          VRImg: "../../../static/img/photo-da/photo_move.jpg",
          ref: "搬运重物体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_move.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "搬运重物体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_ladder.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_ladder.jpg",
          p: "功能：通过人字梯体验，教育不正确使用人字梯时可能出现倾倒的危险性，学习合格人字梯的标准及正确使用方法，提高自我保护意识。",
          VRImg: "../../../static/img/photo-da/photo_ladder.jpg",
          ref: "人字梯体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_ladder.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "人字梯体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_stand.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_stand.jpg",
          p:
            "让体验者感受攀爬劣质爬梯带来的严重后果，所以爬梯根据每个人的特点，设定合理的步距，" +
            "攀爬起来舒适安全，安装牢固，使用材料合格，避免采用锈蚀劣质产品，防腐处理，科学的施工维护，给施工带来方便与安全。",
          VRImg: "../../../static/img/photo-da/photo_stand.jpg",
          ref: "爬梯体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_stand.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "爬梯体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_steel.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_steel.jpg",
          p:
            "规格：2000*2400" +
            "主要材质及内容：全部使用1.2mm厚钢板折弯搭配50*50*3.0mm以及40*40*2.5mm镀锌钢方管焊接而成\n" +
            "功能：通过现场学习各种钢丝绳的使用方法及不合格钢丝绳的报废条件\n" +
            "含钢丝绳捆绑",
          VRImg: "../../../static/img/photo-da/photo_steel.jpg",
          ref: "钢丝绳展示",
          money: "",
          classify: [
            {
              type: "蓝色",
              money: "",
              img: "../../../static/img/photo-da/photo_steel.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "钢丝绳展示",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_labour.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_labour.jpg",
          p:
            "规格：1000*1000*2000\n" +
            "1000*900*900\n" +
            "结构：镀锌方钢、镀锌板 5mm白玻\n" +
            "外观：喷漆+喷绘\n" +
            "假人及各种劳保用品\n" +
            "功能：展示各种合格劳保用品，加强员工的劳动保护概念，劳保用品不是来应付检查的，只有合格的产品才能真正起到保护作用。",
          VRImg: "../../../static/img/photo-da/photo_labour.jpg",
          ref: "劳保用品展示柜",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_labour.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "劳保用品展示柜",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_electrowelding.png",
          photoUrl1: "../../../static/img/photo-da/photo_electrowelding.png",
          p:
            "规格：1500*2300\n" +
            "主要材质及内容：方管、模板以及电焊机配套设备\n" +
            "功能：本体验设施在体验时模拟电焊作业，近距离体验电焊作业，以此警示从事电焊施工的作业者要以严肃的态度对待工作，同时警示每一位建筑工程参与者首先要注意保护自己，远离危险源。",
          VRImg: "../../../static/img/photo-da/photo_electrowelding.png",
          ref: "电焊作业体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_electrowelding.png",
            },
          ],
          title: "建筑工程体验馆",
          belong: "电焊作业体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_annihilator.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_annihilator.jpg",
          p:
            "规格：4000*800*2200\n" +
            "主要材质及内容：1.2mm镀锌钢板和50*50*3.0mm以及40*40*2.5mm镀锌钢管焊接而成\n" +
            "功能：灭火器演示体验包含设备模拟烟雾及灭火器等，含带遥控装置",
          VRImg: "../../../static/img/photo-da/photo_annihilator.jpg",
          ref: "灭火器演示体验",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_annihilator.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "灭火器演示体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_train.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_train.jpg",
          p:
            "规格：2400*800*2300\n" +
            "主要材质及内容：镀锌板搭镀锌管构架，心肺复苏模型使用高科技驱动的教学模拟病人；外罩和急救床使用镀锌管构架，心肺复苏模型使用高科技驱动的教学模拟病人\n" +
            "功能：劳动过程中心脏骤停现象并不罕见，心脏骤停后几分钟病人就会死亡，如果病人能在第一时间得到心肺复苏就会大大增加生还的希望，并为后续专业医务人员的进一步医治赢得宝贵的时间",
          VRImg: "../../../static/img/photo-da/photo_train.jpg",
          ref: "安全急救培训体验",
          money: "",
          classify: [
            {
              type: "乳白色",
              money: "",
              img: "../../../static/img/photo-da/photo_train.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "安全急救培训体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_electro-.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_electro-.jpg",
          p:
            "规格：4000*1200*2300\n" +
            "主要材质及内容：\n" +
            "镀锌方管框架，整体为组装式。外形光线美观，CI喷绘户外写真宣传。\n" +
            "基本常见用电设备配置展示，并有触电感应仪一套。\n" +
            "功能：体验者还能亲自感受安全电流流经人体的感觉，让体验者知晓超强电流的杀伤力是人类无法抵御的，正确引导学习安全用电的知识。",
          VRImg: "../../../static/img/photo-da/photo_electro-.jpg",
          ref: "安全综合用电体验",
          money: "",
          classify: [
            {
              type: "蓝色",
              money: "",
              img: "../../../static/img/photo-da/photo_electro-.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "安全综合用电体验",
          path: "/home/Buy/Experience",
        },
        {
          photoUrl: "../../../static/img/photo/photo_door.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_door.jpg",
          p:
            "规格：4000*400*3500  立柱400 \n" +
            "主要材质及内容：镀锌方钢、镀锌板，40*40与30*30镀锌方管焊接拼接组成外包裹加厚喷绘布，法兰片膨胀螺丝固定\n" +
            "功能：引导观摩，体验及学习者进去体验区。",
          VRImg: "../../../static/img/photo-da/photo_door.jpg",
          ref: "安全区大门",
          money: "",
          classify: [
            {
              type: "",
              money: "",
              img: "../../../static/img/photo-da/photo_door.jpg",
            },
          ],
          title: "建筑工程体验馆",
          belong: "安全区大门",
          path: "/home/Buy/Experience",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
      this.VRImg = item.VRImg;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  white-space: pre-wrap;
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Experience.vue